// extracted by mini-css-extract-plugin
module.exports = {"back":"waitlist_back__1xRNW"};